import { render } from "./FournisseurIndex.vue?vue&type=template&id=4583e208"
import script from "./FournisseurIndex.vue?vue&type=script&lang=js"
export * from "./FournisseurIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__